import { Constant } from '@configs/index';

const keys = {
    GENESISES_DASHBOARD: 'genesisEs/dashBoardParams',
    GENESISES_OPENLIST: 'genesisEs/openParams',
    GENESISES_CLOSELIST: 'genesisEs/closeParams'
};

const defaultValues = {
    'genesisEs/dashBoardParams': Constant.SEARCH_FORM_DATA.DASHBOARD,
    'genesisEs/openParams': Constant.SEARCH_FORM_DATA.DEFAULT,
    'genesisEs/closeParams': Constant.SEARCH_FORM_DATA.CLOSE_DEFAULT
};

const Config = {
    keys,
    defaultValues
};

export default Config;